import { render, staticRenderFns } from "./myrockyinternet-policy.vue?vue&type=template&id=7346a740&"
import script from "./myrockyinternet-policy.vue?vue&type=script&lang=js&"
export * from "./myrockyinternet-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports